"use client";
import Link from "next/link";
import Image from "next/image";
import companyLogo from "public/images/logo/Incluso Logo-onDark.svg";
import CustomButton from "./common/button";
import { useState } from "react";
import { Bars3Icon } from "@heroicons/react/20/solid";
import NavDrawer from "./navbar/navDrawer";
import { INCLUSO_PHONE } from "~/content/value";
import { useActivePath } from "../utils/navHelper";
import { ContactButton } from "./pageSpecific/contact/contactButton";
import PhoneIcon from "./icon/phone2";
import FlyoutMenus from "./navbar/flyoutMenus";
import {
  AboutUs,
  aboutUsLinks,
  ContactUs,
  contactUsLinks,
  Insights,
  serviceLinks,
  Services,
} from "~/content/navLinks";
import { getHeroXPaddingClass } from "~/styles/styles";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const checkActivePath = useActivePath();

  return (
    <nav className="bg-gradient-blue1 py-6">
      <NavDrawer
        isOpen={drawerOpen}
        onClose={setDrawerOpen}
        onClick={handleDrawerToggle}
      />

      {/* Desktop Menu */}
      <div
        className={`container mx-auto hidden grid-cols-12 items-center justify-center ml:grid xl:max-w-7xl ${getHeroXPaddingClass}`}
      >
        <Link href="/" className="col-span-2 flex justify-start">
          <Image
            src={companyLogo as string}
            alt="logo"
            height={66}
            className="xl:w-32"
          />
        </Link>
        <div className="col-span-5 pt-5 xl:pt-6">
          <ul role="list" className="flex text-base text-white xl:text-lg">
            <li>
              <FlyoutMenus
                name={Services.name}
                items={serviceLinks}
                href={Services.href}
              />
            </li>
            <span className="px-1 ml:px-2">|</span>
            <li>
              <Link
                href={Insights.href}
                className={`leading-6 hover:text-orange focus:text-orange ${checkActivePath(Insights.href) ? "text-orange" : ""}`}
              >
                {Insights.name}
              </Link>
            </li>
            <span className="px-1 ml:px-2">|</span>
            <li>
              <FlyoutMenus
                name={AboutUs.name}
                items={aboutUsLinks}
                href={AboutUs.href}
              />
            </li>
            <span className="px-1 ml:px-2">|</span>
            <li>
              <FlyoutMenus
                name={ContactUs.name}
                items={contactUsLinks}
                href={ContactUs.href}
              />
            </li>
          </ul>
        </div>

        <div className="col-span-5 justify-end gap-1 pt-4 text-white md:flex ml:gap-4 2xl:pt-5">
          <ContactButton section="book" className="md:text-sm 2xl:text-base">
            Book a consultation
          </ContactButton>
          <CustomButton
            tel
            href={INCLUSO_PHONE}
            variant="textLink"
            className="px-0 hover:text-gray-300 md:text-base xl:text-lg"
          >
            <PhoneIcon className="size-6 xl:size-7" />
            {INCLUSO_PHONE}
          </CustomButton>
        </div>
      </div>

      {/* Mobile - Hamburger Menu  */}
      <div
        className={`mx-auto grid grid-cols-6 items-center justify-center gap-2 md:container ml:hidden ${getHeroXPaddingClass}`}
      >
        <Bars3Icon
          height={25}
          color="white"
          className="mt-3.5 cursor-pointer"
          onClick={handleDrawerToggle}
        />

        <Link href="/" className="col-span-2 flex justify-center">
          <Image src={companyLogo as string} alt="logo" className="h-14" />
        </Link>
        <div className="col-span-3 mt-3.5 flex items-center justify-end gap-2 sm:gap-4">
          <ContactButton
            section="book"
            className="justify-self-center text-[0.55rem] sm:text-xs"
          >
            Book a consultation
          </ContactButton>
          <CustomButton
            variant="textLink"
            tel
            href={INCLUSO_PHONE}
            className="p-0"
          >
            <PhoneIcon className="size-6" />
          </CustomButton>
        </div>
      </div>
    </nav>
  );
};

export default Header;
